/**
 * @file Openapi Schema
 * @version 0.1.0
 * @author Openapi Generator src_common/server/node_task/run_app/openapi/openapi.ts
 * @date 2025-08-13T08:14:54.316Z
 *
 * Details:
 * --- File generated by generator do not modify this file manually ---
 */

import { z } from 'zod';


// #/components/schemas/casinoStoreCollection
export const CasinoStoreCollectionZod = z.union([z.literal('casino'), z.literal('live-casino'), z.literal('virtuals'), z.literal('bingo')]);
export type CasinoStoreCollectionType = z.TypeOf<typeof CasinoStoreCollectionZod>;


// #/components/schemas/casinoStoreStatus
export const CasinoStoreStatusZod = z.union([z.literal('active'), z.literal('inactive'), z.literal('all')]);
export type CasinoStoreStatusType = z.TypeOf<typeof CasinoStoreStatusZod>;


// #/components/schemas/casinoStoreCategoryModelWithGameIds
export const CasinoStoreCategoryModelWithGameIdsZod = z.object({
    id: z.number(),
    name: z.string(),
    active: z.boolean(),
    fixed: z.boolean(),
    visibleInNavigation: z.boolean(),
    visibleInAllGames: z.boolean(),
    gameIds: z.array(z.number()),
});
export type CasinoStoreCategoryModelWithGameIdsType = z.TypeOf<typeof CasinoStoreCategoryModelWithGameIdsZod>;


// #/components/schemas/casinoStoreProvider
export const CasinoStoreProviderZod = z.union([z.literal('evolution'), z.literal('ezugi'), z.literal('leap'), z.literal('pragmatic'), z.literal('relax'), z.literal('sg-digital'), z.literal('blueprint')]);
export type CasinoStoreProviderType = z.TypeOf<typeof CasinoStoreProviderZod>;


// #/components/schemas/casinoStoreFetchedLiveGameModel
export const CasinoStoreFetchedLiveGameModelZod = z.object({
    id: z.number(),
    providerGameId: z.string(),
    name: z.string(),
    nameAlias: z.string().optional().nullable(),
    demoAvailable: z.boolean(),
    demoEnabled: z.boolean().optional().nullable(),
    providerId: z.number(),
    providerSlug: CasinoStoreProviderZod,
    providerName: z.string(),
    studioId: z.number(),
    studioSlug: z.string(),
    studioName: z.string(),
    studioNameAlias: z.string().optional().nullable(),
    published: z.boolean(),
    imageHorizontal: z.string().optional().nullable(),
    imageVertical: z.string().optional().nullable(),
    imageSquare: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    jackpotAmount: z.string().optional().nullable(),
    returnToPlayer: z.string().optional().nullable(),
    minBetAlias: z.string().optional().nullable(),
    maxBetAlias: z.string().optional().nullable(),
    maxWinAlias: z.string().optional().nullable(),
    providerDefaultMinBet: z.string().optional().nullable(),
    providerDefaultMaxBet: z.string().optional().nullable(),
    providerDefaultMaxWin: z.string().optional().nullable(),
});
export type CasinoStoreFetchedLiveGameModelType = z.TypeOf<typeof CasinoStoreFetchedLiveGameModelZod>;


// #/components/schemas/casinoStoreFetchedCategoriesAndGamesBackofficeModel
export const CasinoStoreFetchedCategoriesAndGamesBackofficeModelZod = z.object({
    categories: z.array(CasinoStoreCategoryModelWithGameIdsZod),
    games: z.array(CasinoStoreFetchedLiveGameModelZod),
});
export type CasinoStoreFetchedCategoriesAndGamesBackofficeModelType = z.TypeOf<typeof CasinoStoreFetchedCategoriesAndGamesBackofficeModelZod>;


// #/components/schemas/casinoStoreHttpErrorResponse
export const CasinoStoreHttpErrorResponseZod = z.object({
    code: z.number(),
    message: z.string(),
});
export type CasinoStoreHttpErrorResponseType = z.TypeOf<typeof CasinoStoreHttpErrorResponseZod>;


// #/components/schemas/casinoStoreHandlerCreateCategoryPayload
export const CasinoStoreHandlerCreateCategoryPayloadZod = z.object({
    name: z.string(),
    position: z.number(),
});
export type CasinoStoreHandlerCreateCategoryPayloadType = z.TypeOf<typeof CasinoStoreHandlerCreateCategoryPayloadZod>;


// #/components/schemas/casinoStoreCategoryModel
export const CasinoStoreCategoryModelZod = z.object({
    id: z.number(),
    name: z.string(),
    active: z.boolean(),
    fixed: z.boolean(),
    visibleInNavigation: z.boolean(),
    visibleInAllGames: z.boolean(),
});
export type CasinoStoreCategoryModelType = z.TypeOf<typeof CasinoStoreCategoryModelZod>;


// #/components/schemas/casinoStoreHandlerCreateCategoryResponse
export const CasinoStoreHandlerCreateCategoryResponseZod = z.object({
    createdCategory: CasinoStoreCategoryModelZod,
});
export type CasinoStoreHandlerCreateCategoryResponseType = z.TypeOf<typeof CasinoStoreHandlerCreateCategoryResponseZod>;


// #/components/schemas/casinoStoreRowsAffectedResult
export const CasinoStoreRowsAffectedResultZod = z.object({
    rowsAffected: z.number(),
});
export type CasinoStoreRowsAffectedResultType = z.TypeOf<typeof CasinoStoreRowsAffectedResultZod>;


// #/components/schemas/casinoStoreEditCategoryModel
export const CasinoStoreEditCategoryModelZod = z.object({
    name: z.string(),
    active: z.boolean(),
    visibleInNavigation: z.boolean(),
    visibleInAllGames: z.boolean(),
});
export type CasinoStoreEditCategoryModelType = z.TypeOf<typeof CasinoStoreEditCategoryModelZod>;


// #/components/schemas/casinoStoreHandlerEditCategoryPayload
export const CasinoStoreHandlerEditCategoryPayloadZod = z.object({
    categoryDetails: CasinoStoreEditCategoryModelZod,
});
export type CasinoStoreHandlerEditCategoryPayloadType = z.TypeOf<typeof CasinoStoreHandlerEditCategoryPayloadZod>;


// #/components/schemas/casinoStoreHandlerEditCategoryResponse
export const CasinoStoreHandlerEditCategoryResponseZod = z.object({
    modifiedCategory: CasinoStoreCategoryModelZod,
});
export type CasinoStoreHandlerEditCategoryResponseType = z.TypeOf<typeof CasinoStoreHandlerEditCategoryResponseZod>;


// #/components/schemas/casinoStoreHandlerChangeCategoryPositionPayload
export const CasinoStoreHandlerChangeCategoryPositionPayloadZod = z.object({
    newPosition: z.number(),
});
export type CasinoStoreHandlerChangeCategoryPositionPayloadType = z.TypeOf<typeof CasinoStoreHandlerChangeCategoryPositionPayloadZod>;


// #/components/schemas/casinoStoreHandlerChangeCategoryPositionResponse
export const CasinoStoreHandlerChangeCategoryPositionResponseZod = z.object({
    modifiedCategory: CasinoStoreCategoryModelZod,
});
export type CasinoStoreHandlerChangeCategoryPositionResponseType = z.TypeOf<typeof CasinoStoreHandlerChangeCategoryPositionResponseZod>;


// #/components/schemas/casinoStoreHandlerAssignGameToCategoryPayload
export const CasinoStoreHandlerAssignGameToCategoryPayloadZod = z.object({
    position: z.number(),
});
export type CasinoStoreHandlerAssignGameToCategoryPayloadType = z.TypeOf<typeof CasinoStoreHandlerAssignGameToCategoryPayloadZod>;


// #/components/schemas/casinoStoreHandlerChangeGamesOrderPayload
export const CasinoStoreHandlerChangeGamesOrderPayloadZod = z.object({
    gameIds: z.array(z.number()),
});
export type CasinoStoreHandlerChangeGamesOrderPayloadType = z.TypeOf<typeof CasinoStoreHandlerChangeGamesOrderPayloadZod>;


// #/components/schemas/casinoStoreEditLiveGameModel
export const CasinoStoreEditLiveGameModelZod = z.object({
    published: z.boolean(),
    demoEnabled: z.boolean(),
    imageHorizontal: z.string().optional(),
    imageVertical: z.string().optional(),
    imageSquare: z.string().optional(),
    description: z.string().optional(),
    jackpotAmount: z.string().optional(),
    returnToPlayer: z.string().optional(),
    nameAlias: z.string().optional(),
    minBetAlias: z.string().optional(),
    maxBetAlias: z.string().optional(),
    maxWinAlias: z.string().optional(),
});
export type CasinoStoreEditLiveGameModelType = z.TypeOf<typeof CasinoStoreEditLiveGameModelZod>;


// #/components/schemas/casinoStoreHandlerEditLiveGamePayload
export const CasinoStoreHandlerEditLiveGamePayloadZod = z.object({
    liveGameDetails: CasinoStoreEditLiveGameModelZod,
});
export type CasinoStoreHandlerEditLiveGamePayloadType = z.TypeOf<typeof CasinoStoreHandlerEditLiveGamePayloadZod>;


// #/components/schemas/casinoStoreHandlerEditLiveGameResponse
export const CasinoStoreHandlerEditLiveGameResponseZod = z.object({
    modifiedGame: CasinoStoreFetchedLiveGameModelZod,
});
export type CasinoStoreHandlerEditLiveGameResponseType = z.TypeOf<typeof CasinoStoreHandlerEditLiveGameResponseZod>;


// #/components/schemas/casinoStoreHandlerChangeGameAssigmentPayload
export const CasinoStoreHandlerChangeGameAssigmentPayloadZod = z.object({
    categoryIds: z.array(z.number()),
});
export type CasinoStoreHandlerChangeGameAssigmentPayloadType = z.TypeOf<typeof CasinoStoreHandlerChangeGameAssigmentPayloadZod>;


// #/components/schemas/casinoStoreGetGamesQueryParams
export const CasinoStoreGetGamesQueryParamsZod = z.object({
    collectionSlug: CasinoStoreCollectionZod.optional(),
    providerSlug: CasinoStoreProviderZod.optional(),
    studioSlug: z.string().optional(),
    collectionId: z.number().optional(),
    providerId: z.number().optional(),
    studioId: z.number().optional(),
    after: z.number().optional(),
    pageSize: z.number().optional(),
    disabledProviders: z.boolean().optional(),
    disabledStudios: z.boolean().optional(),
});
export type CasinoStoreGetGamesQueryParamsType = z.TypeOf<typeof CasinoStoreGetGamesQueryParamsZod>;


// #/components/schemas/casinoStoreFetchedStoreGameModel
export const CasinoStoreFetchedStoreGameModelZod = z.object({
    id: z.number(),
    providerGameId: z.string(),
    collectionId: z.number(),
    collectionSlug: CasinoStoreCollectionZod,
    kind: z.string().optional().nullable(),
    name: z.string(),
    demoAvailable: z.boolean(),
    providerId: z.number(),
    providerSlug: CasinoStoreProviderZod,
    providerName: z.string(),
    studioId: z.number(),
    studioSlug: z.string(),
    studioName: z.string(),
    studioNameAlias: z.string().optional().nullable(),
});
export type CasinoStoreFetchedStoreGameModelType = z.TypeOf<typeof CasinoStoreFetchedStoreGameModelZod>;

